import React, { Component, useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { flattenErrors } from './ErrorHelpers';
import moment from 'moment';
import { createEvent } from 'ics';

const years = Array.from(new Array(20), (x, i) => i + new Date().getFullYear());

export function BookOneOnOneComponent({ accountNumber, bottomMessage, refundText, googleMapsApiKey, postBookingMessage, noDatesAvailableMessage, initialSelectedDate, advisorId }) {
    const [selectedDate, setSelectedDate] = useState(moment().startOf('week'));
    const [loading, setLoading] = useState(true);
    const [timeSlots, setTimeSlots] = useState(null);
    const [selectedTimeSlot, selectTimeSlot] = useState(null);
    const [currentScreen, setScreen] = useState(1);
    const [creditCardForm, setCreditCardForm] = useState({});
    const [errors, setErrors] = useState(null);
    const [times, setTimes] = useState(null);
    const [address, setAddress] = useState({});
    const [comment, setComment] = useState({});
    const [tax, setTax] = useState(0);
    const [rsvpId, setRsvpId] = useState(null);


    function updateComment(e) {
        const inputValue = e.target.value.slice(0, 250);
        setComment({
            ...comment,
            [e.target.name]: inputValue
        });
    }

    function updateAddress(e) {
        setAddress({
            ...address,
            [e.target.name]: e.target.value
        });
    }

    function updateCreditCardForm(e) {
        setCreditCardForm({
            ...creditCardForm,
            [e.target.name]: e.target.value
        });
    }

    useEffect(() => {
        fetch(`/api/talent/oneonone/${advisorId}/timeslots`,
            {
                method: "GET"
            })
            .then(req => req.json())
            .then(resp => {
                const timeslots = {};
                resp = resp.sort((a, b) => moment(a.dateTime).valueOf() - moment(b.dateTime).valueOf());

                for (const i of resp) {
                    i.dateTime = moment(i.dateTime);
                    const currentDate = i.dateTime.format("YYYY-MM-DD");

                    if (!timeslots[currentDate]) {
                        timeslots[currentDate] = [];
                    }
                    timeslots[currentDate].push(i);
                }

                setLoading(false);
                setTimeSlots(timeslots);
            });
    }, []);

    useEffect(() => {
        if (initialSelectedDate && timeSlots) {
            const initialDate = moment(initialSelectedDate).format("YYYY-MM-DD");
            if (timeSlots[initialDate]) {
                selectDate(initialDate);
            }
        }
    },
        [timeSlots]);

    function book() {
        setErrors(null);
        setLoading(true);
        fetch(`/api/talent/${accountNumber}/oneonone/book`,
            {
                method: "POST",
                body: JSON.stringify({
                    ...address,
                    TimeSlotId: selectedTimeSlot.timeSlotId,
                    EventId: selectedTimeSlot.id,
                    Payment: creditCardForm,
                    Source: "Booked by talent on Book One On One page",
                    ...comment
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(req => {
                setLoading(false);
                if (req.ok) {
                    setScreen(3);
                    req.json().then(rsvp => setRsvpId(rsvp.id));
                } else {
                    req.json().then(resp => setErrors(resp.errors));
                }
            });
    }

    function goNext() {
        setErrors(null);
        setLoading(true);
        fetch(`/api/talent/${accountNumber}/photoshoot/calculatesalestax`,
            {
                method: "POST",
                body: JSON.stringify({
                    ...address,
                    eventId: selectedTimeSlot.id
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(req => {
                setLoading(false);
                if (req.ok) {
                    req.json().then(resp => {
                        setTax(resp.tax);
                        setScreen(2);
                    });
                } else {
                    req.json().then(resp => setErrors(resp.errors));
                }
            });
    }

    function getCurrentEventAddress() {
        const location = selectedTimeSlot.eventLocation;
        return `${location.address1}, ${location.address2 || ""}${(location.address2 && ", ") || ""}${location.city}, ${location.state}, ${location.zip}`;
    }

    function getGoogleMapsUrl() {
        return `https://www.google.com/maps/embed/v1/place?key=${googleMapsApiKey}&q=${getCurrentEventAddress()}`;
    }

    function downloadIcs() {
        const e = selectedTimeSlot;
        const d = e.dateTime;
        const event = {
            start: [d.year(), d.month(), d.day(), d.hour(), d.minute()],
            duration: {
                minutes: e.durationInMinutes
            },
            title: "One On One",
            description: "One On One",
            url: "https://myjc.me",
            status: "CONFIRMED",
            busyStatus: "BUSY"
        };

        if (selectedTimeSlot.eventLocation) {
            event.location = getCurrentEventAddress();
        } else {
            event.location = "Zoom";
        }

        createEvent(event,
            (error, value) => {
                window.open("data:text/calendar;charset=utf8," + escape(value));
            });
    }

    function selectDate(date) {
        const times = timeSlots[date];
        setTimes(times);
        setSelectedDate(date);
        selectTimeSlot(null);
    }

    return (
        <>
            {currentScreen === 1 && <div>
                <div className="row">
                    <div className="col-lg-12 col-xl-6">
                        <div id="ps-dates" className="card mb-2">
                            <div className="card-body">
                                <div className="card-title">
                                    <h5 className="text-center">Select a Date</h5>
                                    {timeSlots && !!Object.keys(timeSlots).length && Object.keys(timeSlots).map(date => <button className={"btn btn-block btn-lg " + (date === selectedDate ? "btn-primary" : "btn-outline-primary")}
                                        onClick={() => selectDate(date)}>{moment(date).format("dddd, MMMM Do YYYY")}</button>)}
                                    {timeSlots && !Object.keys(timeSlots).length && <div className="text-center">{noDatesAvailableMessage}</div>}
                                    {loading && <h2 className="text-center">Loading...</h2>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                        <div id="ps-times" className="card mb-2">
                            <div className="card-body">
                                <div className="card-title">
                                    <h5 className="text-center">Select a Time</h5>
                                    {times && times.map(t => <button className="btn btn-lg btn-outline-primary btn-block" style={{ whiteSpace: "nowrap" }}
                                        onClick={() => selectTimeSlot(t)}>{t.dateTime.format("h:mm A")}</button>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xl-10 offset-xl-1">
                        <div className="card mb-2">
                            <div className="card-body">
                                {!selectedTimeSlot &&
                                    <div className="card-title">
                                        <h5 className="text-center">Confirm Details</h5>
                                    </div>}
                                {selectedTimeSlot && <div>
                                    <div className="card-title">
                                        <h3>One on One</h3>
                                    </div>
                                    <h4>{selectedTimeSlot.dateTime.format("LLL")}</h4>

                                    {(selectedTimeSlot.cost > 0 || selectedTimeSlot.preDiscountCost > 0) &&
                                        <h5>Fee: {selectedTimeSlot.preDiscountCost ? <span style={{ color: "grey", textDecoration: "line-through" }}>${selectedTimeSlot.preDiscountCost.toFixed(2)}</span> : ""} ${selectedTimeSlot.cost}</h5>}
                                    <hr />

                                    {selectedTimeSlot.eventLocation && <>
                                        <h4>Location</h4>
                                        <address>
                                            <strong>
                                                {selectedTimeSlot.eventLocation.name}
                                            </strong><br />

                                            {selectedTimeSlot.eventLocation.address1}<br />
                                            {selectedTimeSlot.eventLocation.address2}{selectedTimeSlot.eventLocation.address2 && <br />}
                                            {selectedTimeSlot.eventLocation.city}, {selectedTimeSlot.eventLocation.state} {selectedTimeSlot.eventLocation.zip}
                                        </address>
                                    </>}

                                    {!selectedTimeSlot.eventLocation && <p>Hosted on Zoom</p>}

                                    <hr />
                                    <h4>What would you like to accomplish in this session?</h4>
                                    <div className="form-group">
                                        <input name="comment" className="form-control mr-2" maxLength={250} onChange={updateComment} />
                                    </div>


                                    <hr />
                                    <h4>Enter your address</h4>
                                    <div className="form-group">
                                        <input name="address1" className="form-control mr-2" placeholder="Address 1" onChange={updateAddress} />
                                    </div>
                                    <div className="form-group">
                                        <input name="address2" className="form-control mr-2" placeholder="Address 2" onChange={updateAddress} />
                                    </div>
                                    <div className="form-inline mb-2">
                                        <input name="city" className="form-control col-lg-12 col-xl-6 mb-3" placeholder="City" onChange={updateAddress} />
                                        <select name="state" className="form-control col-lg-12 col-xl-3 mb-3" placeholder="State" onChange={updateAddress}>
                                            <option value="" disabled selected>State</option>
                                            <option value="AL">AL</option>
                                            <option value="AK">AK</option>
                                            <option value="AR">AR</option>
                                            <option value="AZ">AZ</option>
                                            <option value="CA">CA</option>
                                            <option value="CO">CO</option>
                                            <option value="CT">CT</option>
                                            <option value="DC">DC</option>
                                            <option value="DE">DE</option>
                                            <option value="FL">FL</option>
                                            <option value="GA">GA</option>
                                            <option value="HI">HI</option>
                                            <option value="IA">IA</option>
                                            <option value="ID">ID</option>
                                            <option value="IL">IL</option>
                                            <option value="IN">IN</option>
                                            <option value="KS">KS</option>
                                            <option value="KY">KY</option>
                                            <option value="LA">LA</option>
                                            <option value="MA">MA</option>
                                            <option value="MD">MD</option>
                                            <option value="ME">ME</option>
                                            <option value="MI">MI</option>
                                            <option value="MN">MN</option>
                                            <option value="MO">MO</option>
                                            <option value="MS">MS</option>
                                            <option value="MT">MT</option>
                                            <option value="NC">NC</option>
                                            <option value="NE">NE</option>
                                            <option value="NH">NH</option>
                                            <option value="NJ">NJ</option>
                                            <option value="NM">NM</option>
                                            <option value="NV">NV</option>
                                            <option value="NY">NY</option>
                                            <option value="ND">ND</option>
                                            <option value="OH">OH</option>
                                            <option value="OK">OK</option>
                                            <option value="OR">OR</option>
                                            <option value="PA">PA</option>
                                            <option value="RI">RI</option>
                                            <option value="SC">SC</option>
                                            <option value="SD">SD</option>
                                            <option value="TN">TN</option>
                                            <option value="TX">TX</option>
                                            <option value="UT">UT</option>
                                            <option value="VT">VT</option>
                                            <option value="VA">VA</option>
                                            <option value="WA">WA</option>
                                            <option value="WI">WI</option>
                                            <option value="WV">WV</option>
                                            <option value="WY">WY</option>
                                        </select>
                                        <input name="zip" className="form-control col-lg-12 col-xl-3 mb-3" placeholder="ZIP" onChange={updateAddress} maxlength="5" />
                                    </div>
                                    <a href="javascript:void(220221)" className="btn btn-primary btn-block" onClick={goNext}>
                                        Next
                                    </a>

                                    {errors && <ul>
                                        {Object.keys(errors).flatMap(key => errors[key].map(error => <li>{error}</li>))}
                                    </ul>}
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            {currentScreen === 2 && <div className="col-lg-12 col-xl-10 offset-xl-1">
                <div className="card">
                    <div className="card-body">
                        {errors && <ul>
                            {Object.keys(errors).flatMap(key => errors[key].map(error => <li>{error}</li>))}
                        </ul>}

                        <h4>{selectedTimeSlot.dateTime.format("LLL")}</h4>

                        {selectedTimeSlot.eventLocation && <address>
                            <strong>
                                {selectedTimeSlot.eventLocation.name}
                            </strong><br />

                            {selectedTimeSlot.eventLocation.address1}<br />
                            {selectedTimeSlot.eventLocation.address2}{selectedTimeSlot.eventLocation.address2 && <br />}
                            {selectedTimeSlot.eventLocation.city}, {selectedTimeSlot.eventLocation.state} {selectedTimeSlot.eventLocation.zip}
                        </address>}

                        {!selectedTimeSlot.eventLocation && <div>Hosted on Zoom</div>}

                        {selectedTimeSlot.cost > 0 && <div>
                            <div className="row mb-2">
                                <div className="col-lg-12 col-xl-5">
                                    Fee: {selectedTimeSlot.preDiscountCost ? <span style={{ color: "grey", textDecoration: "line-through" }}>${selectedTimeSlot.preDiscountCost.toFixed(2)}</span> : ""} ${selectedTimeSlot.cost.toFixed(2)}
                                </div>
                                <div className="col-lg-12 col-xl-3">
                                    Tax: ${tax.toFixed(2)}
                                </div>
                                <div className="col-lg-12 col-xl-4 font-weight-bold">
                                    Total: ${(tax + selectedTimeSlot.cost).toFixed(2)}
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group col-lg-12 col-xl-6">
                                    <label>Card Number</label>
                                    <input type="tel" name="CreditCardNumber" onChange={updateCreditCardForm}
                                        placeholder="4111 0001 1234 4567" className="form-control" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-lg-12 col-xl-6 mb-3 form-group">
                                    <label>Exp. Month</label>
                                    <select name="ExpirationMonth" className="form-control" onChange={updateCreditCardForm}>
                                        <option>Month</option>
                                        <option value="1">January</option>
                                        <option value="2">February</option>
                                        <option value="3">March</option>
                                        <option value="4">April</option>
                                        <option value="5">May</option>
                                        <option value="6">June</option>
                                        <option value="7">July</option>
                                        <option value="8">August</option>
                                        <option value="9">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                </div>
                                <div className="col-md-12 col-lg-8 col-xl-4 form-group">
                                    <label>Exp. Year</label>
                                    <select name="ExpirationYear" className="form-control" onChange={updateCreditCardForm}>
                                        <option>Year</option>
                                        {years.map(y => <option value={y}>{y}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-12 col-lg-4 col-xl-2 form-group">
                                    <label>CVV</label>
                                    <input type="tel" name="CvvCode" className="form-control" maxlength="4" placeholder="CVV"
                                        style={{ width: "60px" }} onChange={updateCreditCardForm} />
                                </div>
                            </div>
                        </div>}
                        <button className="btn btn-block btn-success" onClick={book} disabled={loading}>
                            Book It!
                        </button>
                        {selectedTimeSlot.cost > 0 && refundText && <p className="mt-2 text-center">{refundText}</p>}
                    </div>
                </div>
            </div>}
            {currentScreen === 3 && <div>
                <h1 className="text-center">You're Booked!</h1>

                <p className="text-center" style={{ fontSize: "large" }}>
                    <strong>Date/Time:</strong> {selectedTimeSlot.dateTime.format("LLL")}
                </p>

                {selectedTimeSlot.eventLocation && <>
                    <h2 className="text-center">Your One on One is located at:</h2>

                    <address className="text-center">
                        <strong>
                            {selectedTimeSlot.eventLocation.name}
                        </strong><br />

                        {selectedTimeSlot.eventLocation.address1}<br />
                        {selectedTimeSlot.eventLocation.address2}{selectedTimeSlot.eventLocation.address2 && <br />}
                        {selectedTimeSlot.eventLocation.city}, {selectedTimeSlot.eventLocation.state} {selectedTimeSlot.eventLocation.zip}
                    </address>
                </>}

                {!selectedTimeSlot.eventLocation && <p className="text-center">Hosted on Zoom - a link to join will be sent to you before your event starts!</p>}

                {selectedTimeSlot.eventLocation && <iframe
                    width="600"
                    height="450"
                    style={{ border: 0, margin: "0 auto", display: "block" }}
                    loading="lazy"
                    allowfullscreen
                    src={getGoogleMapsUrl()}
                    className="mb-2">
                </iframe>}

                <p className='text-center mt-2'>
                    <button className="btn btn-lg btn-primary mr-2" onClick={downloadIcs}>
                        <i className="fa fa-calendar"></i>
                        Add to Calendar
                    </button>
                    {selectedTimeSlot.cost > 0 && <a href={`/BookOneOnOne/Receipt?rsvpId=${rsvpId}&accountNumber=${accountNumber}`} className="btn btn-lg btn-success" target="_blank">
                        <i className="fa fa-usd"></i>
                        Print Receipt
                    </a>}
                </p>
            </div>}

            {bottomMessage && <p className="text-center mt-2">{bottomMessage}</p>}
        </>
    );
}